module.exports = __webpack_public_path__ + "static/img/1692694630316.19478529.jpg";